<template>
    <div class="input_container">
        <van-field v-model="localValue" type="number" :placeholder="labelText" @clear="onClear">
            <template #left-icon>
                <span class="left_icon">R$</span>
            </template>
            <template #right-icon>
                <div  class="right-wrapper">
                    <van-icon v-if="localValue" name="clear" class="custom-clear" @click.stop="onClear" />
                    <div class="right_text" v-if="props.isTopupVisible">
                        {{ $t('deposit.extra') }} <span class="extra_amount">+{{ formatCurrency(giftAmount) }}</span>
                    </div>
                </div>
            </template>
        </van-field>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction'
import { ref, watch} from 'vue'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    labelText: {
        type: String,
        default: ''
    },
    isTopupVisible: {
        type: Boolean,
        default: false
    },
    giftAmount: {
        type: Number,
        default: 0
    }
})

const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const onClear = () => {
    localValue.value = ''
    emit('update:modelValue', '')
    emit('valueChanged', '')
}
</script>
<style scoped>
.input_container>>>.van-field {
    border-radius: 30px;
    background: #101629 !important;
    /* border: 1px solid rgba(221, 122, 51, 1); */
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.left_icon {
    color: rgba(255, 255, 255, 0.65);
    font-size: 17px;
    font-weight: bold;
    padding-right: 10px;
}
.right-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}
.input_container>>>.van-field__control {
    color: #fff !important;
    font-weight: bold;
    font-size: 16px;
}

.input_container>>>.van-field__control::placeholder {
    color: #ffffff40 !important;
    font-size: 15px;
    font-weight: 300;
}

.input_container>>>.van-field__clear {
    opacity: 0.5 !important;
}

.input_container img {
    width: 25px;
    opacity: 0.5;
}

.right_text {
    color: #ffffff73;
}

.extra_amount {
    color: #fff;
    padding: 0 5px;
}

@media (max-width: 360px) {
  .input_container>>>.van-field {
    padding: 8px 12px !important;
    border-radius: 20px;
  }

  .input_container>>>.van-field__control {
    font-size: 14px;
  }

  .input_container>>>.van-field__control::placeholder {
    font-size: 13px;
  }

  .left_icon {
    font-size: 14px;
    padding-right: 6px;
  }

  .right-wrapper {
    gap: 4px;
  }

  .right_text {
    font-size: 11px;
    display: flex;
    align-items: center;
  }

  .extra_amount {
    padding: 0 3px;
    font-size: 11px;
  }

  .custom-clear {
    font-size: 14px;
  }
}

</style>